var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSectors11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 852,
    height: 852,
    viewBox: "0 0 852 852",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M590.886 63.5134C660.228 95.2608 718.985 146.269 760.159 210.463L425.264 425.264L590.886 63.5134Z",
    fill: "url(#paint0_linear_90_26)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M369.205 31.3711C444.708 20.6253 521.709 31.8064 591.038 63.5828L425.264 425.264L369.205 31.3711Z",
    fill: "url(#paint1_linear_90_26)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M823.127 425.958C822.994 502.23 800.941 576.856 759.593 640.948L425.266 425.264L823.127 425.958Z",
    fill: "url(#paint2_linear_90_26)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M759.995 210.206C801.218 274.368 823.132 349.027 823.127 425.292L425.265 425.264L759.995 210.206Z",
    fill: "url(#paint3_linear_90_26)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M758.939 641.955C717.403 705.916 658.358 756.591 588.838 787.946L425.264 425.264L758.939 641.955Z",
    fill: "url(#paint4_linear_90_26)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M367.143 818.859C291.697 807.718 221.042 775.127 163.593 724.969L425.264 425.264L367.143 818.859Z",
    fill: "url(#paint5_linear_90_26)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M588.99 787.877C519.483 819.261 442.42 830.007 366.979 818.834L425.264 425.264L588.99 787.877Z",
    fill: "url(#paint6_linear_90_26)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M165.294 124.085C223.025 74.2521 293.863 42.062 369.371 31.3479L425.265 425.265L165.294 124.085Z",
    fill: "url(#paint7_linear_90_26)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7865 312.265C65.4467 239.141 107.667 173.784 165.419 123.975L425.265 425.264L43.7865 312.265Z",
    fill: "url(#paint8_linear_90_26)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1998 536.265C21.9227 463.029 22.1427 385.22 43.8336 312.106L425.264 425.265L43.1998 536.265Z",
    fill: "url(#paint9_linear_90_26)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M163.718 725.079C106.248 674.945 64.3981 609.349 43.1518 536.104L425.263 425.265L163.718 725.079Z",
    fill: "url(#paint10_linear_90_26)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_90_26",
    x1: 497.944,
    y1: 187.742,
    x2: 694.389,
    y2: 304.427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8362DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B3EAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_90_26",
    x1: 358.107,
    y1: 186.122,
    x2: 586.455,
    y2: 178.186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4A9F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A60C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_90_26",
    x1: 676.431,
    y1: 416.798,
    x2: 602.569,
    y2: 634.844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8362DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B3EAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_90_26",
    x1: 631.75,
    y1: 282.017,
    x2: 687.859,
    y2: 505.292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4A9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A60C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_90_26",
    x1: 640.746,
    y1: 554.583,
    x2: 460.292,
    y2: 697.538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9176DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#805FDA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_90_26",
    x1: 421.736,
    y1: 673.633,
    x2: 200.537,
    y2: 616.387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8362DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B3EAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_90_26",
    x1: 536.732,
    y1: 650.499,
    x2: 307.648,
    y2: 673.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4A9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A60C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_90_26",
    x1: 239.557,
    y1: 260.305,
    x2: 427.428,
    y2: 130.264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8362DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B3EAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_90_26",
    x1: 186.112,
    y1: 380.032,
    x2: 314.349,
    y2: 174.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4A9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A60C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A60C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_90_26",
    x1: 174.583,
    y1: 585.465,
    x2: 199.19,
    y2: 271.306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8362DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B3EAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_90_26",
    x1: 266.873,
    y1: 620.376,
    x2: 150.769,
    y2: 421.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4A9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A60C0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectors11);
export default __webpack_public_path__ + "static/media/sectors-11.8c8aaf2f0607da09eeb03e1e39bce7f3.svg";
export { ForwardRef as ReactComponent };